// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import ticket01Icon from "@/assets/icons/ticket-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Ticket01IconProps = Omit<IconProps, "name">;

export function Ticket01Icon(props: Ticket01IconProps): React.ReactNode {
  return <Icon name={ticket01Icon} {...props} />;
}
